import { ApiProperty } from "@nestjs/swagger";

export class IndentAbstractRequest {
    
    @ApiProperty()

    fromDate: Date;
    @ApiProperty()

    toDate: Date;
    constructor(fromDate: Date, toDate: Date) {
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
}